<!-- 系统管理-菜单管理 -->
<template>
  <div >
    <!-- 卡片 -->
    <md-card class="full-window-card">
      <!-- 卡片-主体 -->
      <md-card-content>
        <h3>{{$I18n("app_man_1")}}</h3>
        <div class="approvals-form" style="margin-bottom: 45px;">
          <common-form-item 
            class="up-items right-items"
            style="margin-bottom: 16px;"
            :labelweight="200"
            v-for="item in form_data" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
              
        
        <h3>{{$I18n("app_man_2")}}</h3>
        <div class="approvals-form" style="margin-bottom: 45px;">
          <common-form-item 
            style="margin-bottom: 16px;"
            :labelweight="100"
            v-for="item in form_data_pro" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          >
            <div slot="label" style="min-width: 200px;text-align: right;padding:0 15px;font-weight: 400;">
              <img :src="formData.Form.approve_user_icon" style="width: 36px;height: 36px;border-radius: 18px;margin-right: 6px;" />
              *{{$I18n("app_man_6")}}
            </div>
          </common-form-item>
          <div style="text-align: center;">
            <md-button @click="backTable" class="diy-black left-icon">{{$I18n("back")}}</md-button>
            <md-button @click="modalAgree" class="diy-back-blue left-icon md-info">{{$I18n("agree")}}</md-button>
            <md-button @click="modalRefuse" class="diy-back-blue md-info">{{$I18n("refuse")}}</md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
export default {
  data() {
    return {
      value: null,
      formData :new FormClass({ // 弹窗-表单数据
        reason: {
          init : "",
          check: function(val){
            if(!val){
              return false
            }
            return val.length > 200
          }
        },
      }),
    };
  },
  watch: {

  },
  computed: {
    form_data(){
      return [
        {
          label   : this.$I18n("type_appr"),
          keys    : "type",
          type    : "select",
          options : this.$Param.typeAppr.map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          }),
          disabled: true,
        },{
          label   : this.$I18n("app_man_4"),
          keys    : "create_date",
          type    : "input",
          disabled: true,
        },{
          label   : this.$I18n("app_man_5"),
          keys    : "detail_info",
          type    : "textarea",
          disabled: true,
        },{
          label   : this.$I18n("subject"),
          keys    : "remark",
          type    : "textarea",
          disabled: true,
        },{
          label   : this.$I18n("review_comm"),
          keys    : "reason",
          hide    : this.formData.Form.state === 2,
          type    : "textarea",
        },
      ]
    },
    form_data_pro(){
      return [
        {
          // label   : this.$I18n("app_man_6"),
          keys    : "approve_user_name",
          type    : "input",
          disabled: true,
        },

      ]
    },
  },
  methods: {
    open(data){
      if(!data){
        return
      }
      data = {
        ...data,
        approver_user: this.UserInfo.name,
        detail_info :`${this.$I18n("name")}:${data.req_user_name}\n${this.$I18n("join_dep")}:${data.dept_name}\n${this.$I18n("phone_email")}:${data.req_user_id}`,
      }
      this.formData.Update({
        ...data,
        approver_user: this.UserInfo.name,
      });
    },
    close(){
      if(this.$listeners["close"]){
       this.$emit('close');
      }
    },
    backTable(){
      this.$emit('close', false)
    },
    modalAgree(){
      if(this.formData.Check()){
        this.$errorMsg(this.$I18n("appr_comm"))
        return
      }
      this.$confirm(this.$I18n("confir_apply"), this.$I18n("present"), {
        confirmButtonText: this.$I18n("certainty"),
        cancelButtonText : this.$I18n("cancle"),
        type: 'info'
      }).then(() => {
        this.submitAgree();
      }).catch(() => { })
    },
    modalRefuse(){
      if(this.formData.Check()){
        this.$errorMsg(this.$I18n("appr_comm"))
        return
      }
      this.$confirm(this.$I18n("confir_reject"), this.$I18n("present"), {
        confirmButtonText: this.$I18n("certainty"),
        cancelButtonText : this.$I18n("cancle"),
        type: 'info'
      }).then(() => {
        this.submitRefuse();
      }).catch(() => { })
    },
    submitRefuse(){
      this.$api.s_Appr({
        ...this.formData.Form,
        state: 3,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("success"));
          // this.close();
        }))
        .catch(this.$Catch(this.$I18n("error")))
    },
    submitAgree(){
      this.$api.s_Appr({
        ...this.formData.Form,
        state: 2,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("success"));
          // this.close();
        }))
        .catch(this.$Catch(this.$I18n("error")))
    },
  },
}
</script>
<style scoped>
  h3{
    font-size: 13px;
    font-weight: 700;
    border-left: 2px #129BFF solid;
    padding-left: 4px;
  }
  .approvals-form{
    width: 480px;
  }

  .info-cards{
    display: flex;
    margin: 5px -12.5px;
  }
  .info-card{
    width: 265px;
    height: 140px;
    border-radius: 6.5px;
    border: 1px solid #D9D9D9;
    color: #FFFFFF;
    margin: 0 12.5px;
  }
  .info-card .title, .info-card .body{
    color: #FFF;
    margin-top: 18px;
    margin-left: 20px;
  }
  .info-card .title{
    font-size: 16.5px;
    font-weight: 700;
  }
  .info-card .body{
    display: flex;
    margin-top: 15px;
  }
  .info-card .number{
    margin-left: 20px;
    font-size: 45px;
    font-weight: 700;
    line-height: 50px;
  }
  .type-icon{
    width: 50px;
    height: 50px;
  }

</style>